import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import Modal from 'react-modal'
import ModalContent from "../../common/Modal/ModalContent";
import close_modal from '../../assets/ic_close_wh.svg'
import api from "../../utils/api";
import { toast } from "react-toastify";

const CustomHeader = ({ displayName }) => {
    return (
        <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
            {displayName}
        </div>
    );
};

const PartnerListTable = (props) => {

    const [rowData, setRowData] = useState([]);


    const gridRef = useRef()
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

    const [partnerId, setPartnerId] = useState()

    const confirmDisassociate = (name) => {
        const partner = props.partnerList.find((ele) => ele.sName === name);
        setPartnerId(partner.id)
        openConfirmationModalisTrue()
    }

    const disassociateBtn = () => {

        let payload = {
            sServiceCode_list: [props.selectedServiceNames.value],
        }
        const { tempDisassociatePartner } = api.disassociatePartner(payload, partnerId)
            .then(({ data }) => {
                console.log("Donee", data)
                props.getTableData()
                toast("Disassociated Service Partner", {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                })
            })
        console.log(partnerId, payload)
        setConfirmationModal(false)
    }

    const [confirmationModal, setConfirmationModal] = useState(false)
    const openConfirmationModalisTrue = () => {
        setConfirmationModal(true)
    }

    const openConfirmationModalisFalse = () => {
        setConfirmationModal(false)
    }

    useEffect(() => {
        const updatedRowData = props.serviceList
            ? props.serviceList.map((name, index) => ({ name, id: index + 1 }))
            : [];
        setRowData(updatedRowData);
    }, [props.serviceList]);

    const columnDefs = [
        {
            headerName: 'Names', field: 'name', width: 1000,
            headerComponentFramework: CustomHeader
        },
        {
            headerName: 'Actions',
            flex: 1,
            cellRendererFramework: (params) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                        <button
                            style={{
                                width: "200px",
                                margin: '5px 5px'
                            }}
                            onClick={() => confirmDisassociate(params.data.name)}
                            className={`my-services-model-submit-btn`}>Disassociate</button>
                    </div>
                );
            },
            headerComponentFramework: CustomHeader,
        },
    ];

    return (
        props.serviceList === undefined ? (
            ""
        ) : (
            <>

                {/* Confirmation Modal */}

                <Modal isOpen={confirmationModal} style={{ zIndex: 1 }}>
                    <ModalContent className="confirmation-modal-small">
                        <div className="modal-header" style={{
                            backgroundColor: '#76287C',
                            color: '#fff'
                        }}>
                            <span className="modal-title">Confirm</span>
                            <img
                                alt="close"
                                id="Close"
                                src={close_modal}
                                className="close modal-close"
                                onClick={openConfirmationModalisFalse}
                            />
                        </div>

                        <div className="modal-body">
                            Are you sure you want to perform this action?
                            <div className="row">
                                <div className="col-12 d-flex align-items-center" style={{
                                    justifyContent: 'flex-end'
                                }}>
                                    <button
                                        type="button"
                                        className="my-services-model-submit-btn conv-mr25"
                                        onClick={disassociateBtn}>
                                        Yes
                                    </button>
                                    <button
                                        type="button"
                                        className="my-services-model-cancel-btn conv-mr25"
                                        onClick={() => {
                                            openConfirmationModalisFalse()
                                        }}>
                                        No
                                    </button>
                                </div>

                            </div>
                        </div>
                    </ModalContent>
                </Modal>
                <div className="container-fluid" style={{
                    height: "30vh",
                }}>
                    <div style={{ height: "100%", boxSizing: "border-box" }}>
                        <div style={gridStyle} className="ag-theme-material">
                            <AgGridReact
                                ref={gridRef}
                                rowData={rowData}
                                columnDefs={columnDefs}
                                overlayNoRowsTemplate={
                                    '<span class="ag-overlay-loading-center">No Partner Associated</span>'
                                }

                            >
                            </AgGridReact>
                        </div>
                    </div>
                </div>
            </>
        )
    );
}

export default PartnerListTable
